import React from 'react';
import PropTypes from 'prop-types';
import { Logo } from '@els/els-react--logo';
import { RESPONSE_STATUS } from '@Pages/Login/ResetPasswordWithTokenDialog/ResetPasswordWithTokenDialogConstants';

function ResetPasswordWithTokenDialogHeader({ responseStatus }) {
  const isSuccess = responseStatus === RESPONSE_STATUS.SUCCESS;
  const isError = responseStatus === RESPONSE_STATUS.ERROR;

  let title = 'Reset Password';
  if (isError) {
    title = 'Reset link expired';
  } else if (isSuccess) {
    title = 'Password reset';
  }

  return (
    <div className="reset-password-with-token-dialog__header">
      <Logo className={`${isSuccess ? 'logo-success' : 'logo'} u-els-padding-bottom-1x1o2`} />
      <h1 className="u-els-color-text u-els-font-size-h4">{title}</h1>
    </div>
  );
}

ResetPasswordWithTokenDialogHeader.propTypes = {
  responseStatus: PropTypes.string,
};

export default ResetPasswordWithTokenDialogHeader;
